import {  createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface iAdminUSerParameterState {
    user_id : string;
}

const initialState: iAdminUSerParameterState = {
    user_id: "",
};

export const adminUserParameterSlice = createSlice({
    name: "adminUserParameter",
    initialState,
    reducers: {
        setUserId: (state, action: PayloadAction<{ user_id: string }>) => {
            state.user_id = action.payload.user_id;
        }
    },
});

export const { setUserId } = adminUserParameterSlice.actions;
export default adminUserParameterSlice.reducer;